// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function ResellerPrepayTotal() {
   const state = useQuoteContext()
   const { getString } = state

   // Helper function to format prepay length as human-readable string
   const formatPrepayLength = (months) => {
      if (months === 12) return ' (1 year):'
      if (months === 24) return ' (2 years):'
      if (months === 36) return ' (3 years):'
      if (months > 1) return ` (${months} months):`
      return ':'
   }

   if (state.resellerCustomerQuoteValues.prepayDiscountAmount > 0)
      return (
         <div className='row'>
            <div className='col-bhr1 col-bhr5'>
               {getString('product.ResellerPrepayTotal.Title')}
               {formatPrepayLength(state.prepayLength)}
            </div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'>
               {formatFloatAsCurrencySymbol(
                  state.resellerCustomerQuoteValues.annualPrepayTotal,
                  state.currencyObject,
               )}
            </div>
         </div>
      )
}
